export default __webpack_public_path__ + "static/media/Shard-Blade of Wraal.85c5e3c7.jpg";